import { render } from "./TimerCard.vue?vue&type=template&id=3a1bf6ff&scoped=true&ts=true"
import script from "./TimerCard.vue?vue&type=script&lang=ts"
export * from "./TimerCard.vue?vue&type=script&lang=ts"

import "./TimerCard.vue?vue&type=style&index=0&id=3a1bf6ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1bf6ff"]])

export default __exports__